import { CompareDurationDefinitionInfo } from '@modules/quantify/components/QuantifyDefinitionInfo';
import {
  DEFAULT_COMPARE_DURATION_A_NAME,
  DEFAULT_COMPARE_DURATION_B_NAME,
} from '@modules/quantify/constants';
import {
  useGetFormattedDurationFieldLabels,
  useIsDashboardDurationApplied,
} from '@modules/quantify/hooks';
import { useGetCompareColors } from '@modules/quantify/hooks/useGetCompareColors';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { CircleRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { QuantifyDefinitionInfoItem } from './QuantifyDefinitionInfoItem';

interface QuantifyDurationDefinitionInfoProps {
  shouldShowDashboardFiltersSeparately: boolean;
}

export const QuantifyDurationDefinitionInfo = ({
  shouldShowDashboardFiltersSeparately,
}: QuantifyDurationDefinitionInfoProps) => {
  const { colorA, colorB } = useGetCompareColors();
  const { durationLabel, compareDurationLabel } =
    useGetFormattedDurationFieldLabels();
  const compareDurationAName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.baseQueryName || DEFAULT_COMPARE_DURATION_A_NAME,
  );
  const compareDurationBName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.deltaQueryName || DEFAULT_COMPARE_DURATION_B_NAME,
  );
  const isDashboardDurationApplied = useIsDashboardDurationApplied();

  if (compareDurationLabel.primary) {
    return (
      <>
        <QuantifyDefinitionInfoItem
          leftNode={
            <Stack direction="row" alignItems="center" spacing={0.6}>
              <CircleRounded sx={{ color: colorA, width: 8 }} />
              <Typography variant="caption">{compareDurationAName}:</Typography>
            </Stack>
          }
          rightNode={<CompareDurationDefinitionInfo compareField="A" />}
        />
        <QuantifyDefinitionInfoItem
          leftNode={
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <CircleRounded sx={{ color: colorB, width: 8 }} />
              <Typography variant="caption">{compareDurationBName}:</Typography>
            </Stack>
          }
          rightNode={<CompareDurationDefinitionInfo compareField="B" />}
        />
      </>
    );
  }

  return (
    <QuantifyDefinitionInfoItem
      leftNode="Duration:"
      rightNode={
        <Stack>
          <Typography
            variant="caption"
            color={isDashboardDurationApplied ? 'info.main' : 'inherit'}
          >
            {durationLabel.primary}
          </Typography>
          {durationLabel.secondary && (
            <Typography
              variant="caption"
              color={isDashboardDurationApplied ? 'info.main' : 'inherit'}
            >
              {durationLabel.secondary}
            </Typography>
          )}
        </Stack>
      }
    />
  );
};
